import React, { useEffect, useState, useMemo } from 'react';
import SelectSearch, { fuzzySearch } from 'react-select-search';

export default function MultiList({ options, setOptions, preSelectedOption = [], disabled, placeholder, error = '' }) {
  const [selectedOptions, setSelectedOptions] = useState([]);

  useEffect(() => {
    let selection = [];
    for (let i = 0; i < selectedOptions?.length; i++) {
      selection.push(selectedOptions[i]);
    }
    setOptions(selection);
  }, [selectedOptions]);

  useEffect(() => {
    if (preSelectedOption?.length > 0) {
      setSelectedOptions(preSelectedOption);
    }
  }, [preSelectedOption?.length]);

  const onSelect = (value) => {
    if (Array.isArray(value)) {
      setSelectedOptions(value);
      return;
    }
    setSelectedOptions((prev) => {
      if (!prev) return [value];
      const exists = prev.includes(value);
      return exists ? prev.filter((v) => v !== value) : [...prev, value];
    });
  };

  const retainSelectedFuzzy = useMemo(() => {
    return (opts) => {
      const base = fuzzySearch(opts);
      return (query) => {
        const filtered = base(query);
        if (!Array.isArray(selectedOptions) || selectedOptions.length === 0) return filtered;
        const filteredValues = new Set(filtered.map((o) => o.value));
        const selectedFull = opts.filter((o) => selectedOptions.includes(o.value));
        const missingSelected = selectedFull.filter((o) => !filteredValues.has(o.value));
        return [...missingSelected, ...filtered];
      };
    };
  }, [selectedOptions]);

  return (
    <>
      <div>
        <SelectSearch
          options={options}
          value={selectedOptions}
          name="language"
          placeholder={placeholder}
          multiple
          printOptions="on-focus"
          search
          debounce={300}
          filterOptions={retainSelectedFuzzy}
          closeOnSelect={false}
          onChange={onSelect}
          disabled={disabled}
          className={`select-search ${error !== '' ? 'error-border' : null}`}
        />
      </div>
      {error !== '' ? <p style={{ color: '#dc3545', fontSize: '0.875em' }}>{error}</p> : null}
    </>
  );
}
